export * from './src/tips-settings-v1-tip-settings-tip-settings.universal.js';
